module.exports = __webpack_public_path__ + "img/compartilhamento.18aa6d99.svg";